import styled from 'styled-components'
import { colors } from 'shared/assets/styles'
import { CameraSight } from '../../../app-v2/assets/icons/CameraSight'
import { media, style } from '../../assets/styles'
import { fonts } from '../typography'

export const StyledPermissionErrorContainer = styled.div`
    padding: 40px 20px;
    box-sizing: border-box;
    width: 100%;
    position: absolute;
    margin-top: 54px;
    top: 0;
    bottom: 0;
    display: flex;
    justify-content: flex-start;
    gap: 32px;
    align-items: center;
    flex-direction: column;
    background: ${colors.mayoEggWhite};
    img {
        padding: 0 65px;
        width: 100%;
        max-width: 350px;
        box-sizing: border-box;
    }
`

export const StyledPermissionErrorTextContainer = styled.div`
    width: 100%;
    max-width: 320px;
    display: flex;
    justify-content: flex-start;
    gap: 32px;
    align-items: center;
    flex-direction: column;
`
export const StyledScannerOverlay = styled.div`
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 2;
    max-width: 400px;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding-top: calc(100px);
    ${media.medium`
            padding-top: calc(100px - (90px - 54px));
    `}
    gap: 48px;
    p {
        color: ${props => props.idleColor || colors.mayoEggWhite};
        font-family: ${fonts.flameSansRegular};
        font-size: 16px;
        text-shadow: 0 0 1px ${colors.bbqBrown};
        max-width: 180px;
        text-align: center;
    }
`
export const StyledSight = styled(CameraSight)`
    width: calc(100% - 96px);
`

export const modalStyle = {
    ...style.classicModalMobileStyle,
    content: {
        ...style.classicModalMobileStyle.content,
        height: undefined,
        background: colors.mayoEggWhite
    }
}

export const StyledErrorDisplayContainer = styled.div`
    width: 100%;
    background: ${colors.fieryRed};
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: 3;
    ${media.medium`
         top: calc(90px - 54px);
    `}
    display: flex;
    padding: 8px 24px;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    gap: 12px;
    svg {
        flex: none;
    }
`

export const StyledLoaderWrapper = styled.div`
    height: 50px;
    width: 100%;
`
